import axios, { AxiosInstance, AxiosResponse, ResponseType } from 'axios';

type IHandler = (
  value: AxiosResponse<any, any>,
) => AxiosResponse<any, any> | Promise<AxiosResponse<any, any>>;
type IErrorHandler = (error: any) => any;

interface IHandlers {
  before?: IHandler;
  success?: IHandler;
  anyway?: IHandler;
  error?: IErrorHandler;
}

interface UploadFile {
  apiUrl: string;
  fileId: string;
  file: File;
  value?: unknown;
}

class ApiClientModule {
  // eslint-disable-next-line no-use-before-define
  private static _singletonInstance: ApiClientModule;

  constructor() {
    // if(ApiClientModule._singletonInstance) {
    // 	return ApiClientModule._singletonInstance;
    // }
    this.instance = axios.create();
    // ApiClientModule._singletonInstance = this;
  }

  private readonly instance: AxiosInstance;

  private getInstance = ({ success, error }: IHandlers) => {
    //Сначала очищаем, из-за того что повторный use не перезаписывает интерцепторы
    // @ts-ignore
    if (typeof this.instance.interceptors.response?.clear === 'function')
      // @ts-ignore
      this.instance.interceptors.response.clear();
    this.instance.interceptors.response.use(success, error);
    return this.instance;
  };

  public post = (url: string, request: any, handlers: IHandlers) => {
    const api = this.getInstance(handlers);
    api.post(url, request);
  };

  public get = (url: string, query: any, handlers: IHandlers) => {
    const api = this.getInstance(handlers);
    api.get(`${url}`, { params: { ...query } });
  };

  public getFileBlob = (url: string, query: any, handlers: IHandlers) => {
    const api = this.getInstance(handlers);
    api.get(`${url}`, { params: { ...query }, responseType: 'blob' });
  };

  public getFileArrayBuffer = (
    url: string,
    query: any,
    handlers: IHandlers,
  ) => {
    const api = this.getInstance(handlers);
    api.get(`${url}`, { params: { ...query }, responseType: 'arraybuffer' });
  };

  public getFileByUrl = (
    url: string,
    responseType: ResponseType = 'blob',
    handlers: IHandlers,
  ) => {
    const api = this.getInstance(handlers);
    api.get(url, { responseType });
  };

  public getControl = (url: string, query: any, handlers: IHandlers) => {
    const api = this.getInstance(handlers);
    api.get(url, { params: { ...query }, responseType: 'json' });
  };

  public uploadFile = (
    { apiUrl, fileId, file, value }: UploadFile,
    handlers: IHandlers,
  ) => {
    const api = this.getInstance(handlers);
    const data = new FormData();

    data.append('file', file);
    // data.append("value", JSON.stringify(value ?? {}));
    data.append('fileId', fileId);

    api.post(apiUrl, data);
  };

  public deleteFile = ({ apiUrl }: { apiUrl: string }, handlers: IHandlers) => {
    const api = this.getInstance(handlers);

    api.delete(apiUrl);
  };

  public getPreFilledFile(url, applicantType, memberId, handlers: IHandlers) {
    const api = this.getInstance(handlers);

    const fullUrl = memberId
      ? `${url}${applicantType}/${memberId}`
      : `${url}${applicantType}`;
    api.get(fullUrl);
  }
}

export default ApiClientModule;
